import { compose, round, max, partition } from 'lodash/fp';

const calcBucketSpan = compose(round, (x) => x / 4, max);

const makeLabel = ({ span }, isLast) => {
  if (span.from === span.to) return `${span.from}`;
  if (isLast) return `${span.from}+`;
  return `${span.from}-${span.to}`;
};

export const createBuckets = (xs, span = calcBucketSpan(xs), buckets = 5) =>
  Array(buckets)
    .fill(null)
    .reduce(
      (acc, _x, i, arr) => {
        const [match, ys] = partition((g) => g <= span * i, acc[0]);
        return i === arr.length - 1
          ? [...acc[1], match]
          : [ys, [...acc[1], match]];
      },
      [xs, []]
    )
    .map((ys, i, arr) => ({
      logins: ys.length,
      span: {
        from: i === 0 ? 0 : span * i - span + 1,
        to: i === arr.length - 1 ? max(xs) : span * i,
      },
    }))
    .map((x, i, arr) => ({
      label: i === arr.length - 1 ? makeLabel(x, true) : makeLabel(x),
      ...x,
    }));
